import { initContract } from '@ts-rest/core';
const c = initContract();
/**
 * Generated file download (xlsx or csv). The fetch client parses `text/*`
 * responses (csv) as a string and everything else (xlsx) as a Blob —
 * normalize with a `Blob | string` union before saving.
 */
export const FileDownloadResponse = c.otherResponse({
    contentType: 'application/octet-stream',
    body: c.type(),
});
